import { format, parseISO } from 'date-fns'

export const formatPostDate = function (inputDate) {
  const dateFnsFormat = 'MMMM d, yyyy'
  const dateFnsString = format(parseISO(inputDate), dateFnsFormat)
  return dateFnsString
}